module.exports = __webpack_public_path__ + "img/3.07.85349b75.jpg";